import { MediaSummaryCard, type MediaSummaryView } from '../MediaSummaryCard/MediaSummaryCard';
import type { WidgetBlockProps } from '../shared/cardShell';

export type MediaNegativeMentionsCardProps = WidgetBlockProps & { view?: MediaSummaryView };

/** Figma `2123:83789` — `negativeMentions` over coverage rows. */
export function MediaNegativeMentionsCard(props: MediaNegativeMentionsCardProps) {
  return (
    <MediaSummaryCard
      {...props}
      title="Negative mentions"
      helpText="How many of those stories covered your brand critically."
      helpSupportingText="A count rather than a rate. Rising is worse, which is why its badge goes red when the number goes up."
    />
  );
}
